import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { getTranslations } from "../../Shared/translations";

interface MyProps {
  visible: boolean;
  onQdmClose: (visible: boolean, type: "individual" | "group", fixtureCount: number) => any;
  onQdmSelect: (type: "individual" | "group") => any;
}

const QdmOptions: React.FC<MyProps> = ({ visible, onQdmClose, onQdmSelect }) => {
  const [qdmChoice, setQdmChoice] = useState<"individual" | "group">("individual");
  const [fixtureCount, setFixtureCount] = useState<number>(1);
  const t = getTranslations();

  const handleClose = () => {
    onQdmClose(false, qdmChoice, qdmChoice === "group" ? fixtureCount : 0);
    // Reset state so the modal is clean next time it opens
    setQdmChoice("individual");
    setFixtureCount(1);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as "individual" | "group";
    setQdmChoice(value);
    onQdmSelect(value);
  };

  const handleFixtureCountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = Math.max(1, parseInt(event.target.value, 10) || 1);
    setFixtureCount(val);
  };

  return (
    <Modal show={visible}>
      <Modal.Header>
        <Modal.Title>
          <h1>QDM01</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormControl className="projectsFrom">
          <FormLabel id="qdm-radio-group-label">{t.qdmAddressType ?? "Address type"}</FormLabel>
          <RadioGroup
            aria-labelledby="qdm-radio-group-label"
            name="qdm-radio-group"
            className="customCardName"
            onChange={handleChange}
            value={qdmChoice}
          >
            <FormControlLabel
              key={"qdm-individual"}
              value={"individual"}
              control={<Radio />}
              label={t.qdmIndividual ?? "Individual address"}
            />
            <FormControlLabel
              key={"qdm-group"}
              value={"group"}
              control={<Radio />}
              label={t.qdmGroup ?? "Group address"}
            />
          </RadioGroup>
          {qdmChoice === "group" && (
            <Box sx={{ mt: 2 }}>
              <FormLabel sx={{ display: "block", mb: 0.5, fontSize: "0.85rem" }}>
                {t.qdmFixtureCount ?? "Number of fixtures in group"}
              </FormLabel>
              <TextField
                type="number"
                value={fixtureCount}
                onChange={handleFixtureCountChange}
                inputProps={{ min: 1 }}
                size="small"
              />
            </Box>
          )}
        </FormControl>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QdmOptions;
